module.exports = __webpack_public_path__ + "static/media/19.750d7ce7.jpg";